import ContextMenuImplementation from './implementation/ContextMenuImplementation';
var ContextMenuComponent = ContextMenuImplementation;
export default ContextMenuComponent;
//# sourceMappingURL=ContextMenuComponent.js.map